import { FormBase } from 'core/components';

export default class NikoPatientInformationBarForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'firstName',
                    placeholder: 'IMPORT_PATIENT.CREATE.FIRST_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'lastName',
                    placeholder: 'IMPORT_PATIENT.CREATE.LAST_NAME_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'dateOfBirth',
                    placeholder: 'IMPORT_PATIENT.CREATE.DATE_OF_BIRTH_PLACEHOLDER',
                },
                {
                    name: 'ssn',
                    placeholder: 'Enter SSN',
                    rules: 'string'
                },
                {
                    name: 'gender',
                    placeholder: 'Select Gender',
                }
            ],
        };
    }
}
